var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-base",class:_vm.classes,attrs:{"disabled":_vm.disabled}},[(_vm.icon)?_c('svg-icon',{staticClass:"button-base__icon",attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"button-base__text",class:_vm.contentClasses},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }